var ARTIFACT_GROUP_ID = 'com.wixpress.cloud.auto-generated-edms';
var AS_ADMIN_NAMESPACE_NAME = 'withPermissions';
export { ARTIFACT_GROUP_ID, AS_ADMIN_NAMESPACE_NAME };
//# sourceMappingURL=constants.js.map